import { FC } from 'react';
import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	TextField,
} from '@mui/material';
import { TConfirmationDialogWithCommentProps } from './types';

export const ConfirmationDialogWithComment: FC<TConfirmationDialogWithCommentProps> = ({
	open,
	setClose,
	handleConfirm,
	title = '',
	text = '',
	comment,
	setComment,
	confirmButtonText = 'Confirm',
	cancelButtonText = 'Cancel',
}) => {
	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '500px',
					maxWidth: '500px',
					borderRadius: '12px',
				},
			}}
		>
			{title && <DialogTitle color="primary">{title}</DialogTitle>}
			<DialogContent>
				{text && <DialogContentText>{text}</DialogContentText>}
				<TextField
					label="Comment"
					multiline
					rows={4}
					sx={{
						width: '100%',
						marginTop: '20px',
					}}
					value={comment}
					onChange={(e) => setComment(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>{cancelButtonText}</Button>
				<Button onClick={() => handleConfirm(comment)} autoFocus>
					{confirmButtonText}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
